import React, { Component } from 'react';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import AutofacturacionTicketStatus from '../../enum/AutofacturacionTicketStatus';

class AutofacturacionItemActions extends Component {
  state = {};

  handleOnAction = async (status) => {
    const { onSuccess, selectedRowKeys } = this.props;

    this.setState({
      busy: true,
    });

    try {
      const response = await Http.patch('api/autofacturacion/tickets', {
        busy: false,
        status,
        tickets: selectedRowKeys,
      });

      !!onSuccess && onSuccess(response);
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message:
          error.data?.message ?? error.message ?? 'Ha ocurrido un error procesando tu solicitud, intenta más tarde.',
      });
    }
  };

  handleOnRetryIndividual = async (status) => {
    this.setState({
      busy: true,
    });

    try {
      const response = await Http.post('api/autofacturacion/retry', {
        status,
        ids: this.getTicketsQueuedKeys(),
      });

      this.setState({
        busy: false,
      });

      window.ToastManager.show({
        variant: 'success',
        title: 'Success',
        message: response.data?.message ?? response.message ?? 'Se han reservado los recursos para procesar tu solicitud.',
      });
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message:
          error.data?.message ?? error.message ?? 'Ha ocurrido un error procesando tu solicitud, intenta más tarde.',
      });
    }
  };

  getTicketsQueuedKeys = () => {
    const { selectedRows } = this.props;

    return selectedRows
      .filter((item) => item.status === AutofacturacionTicketStatus.queued().getValue())
      .map((item) => item.id);
  };

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { busy } = this.state;

    const ticketsQueuedKeys = this.getTicketsQueuedKeys();

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={alignRight}
      >
        {selectedRowKeys.length > 0 && (
          <LoadingButton
            variant="secondary"
            loading={busy}
            onClick={this.handleOnAction.bind(this, 11)}
          >
            {busy ? 'Procesando...' : 'Bloquear'}
          </LoadingButton>
        )}

        {selectedRowKeys.length > 0 && (
          <>
            <Dropdown.Toggle
              split
              variant="secondary"
              id="dropdown-split-basic"
            />
            <Dropdown.Menu>
              <Dropdown.Item
                as="div"
                onClick={this.handleOnAction.bind(this, 11)}
              >
                Bloquear
              </Dropdown.Item>
              <Dropdown.Item
                as="div"
                onClick={this.handleOnAction.bind(this, 0)}
              >
                Liberar
              </Dropdown.Item>

              {ticketsQueuedKeys.length > 0 && (
                <Dropdown.Item
                  as="div"
                  onClick={this.handleOnRetryIndividual.bind(this, 8)}
                >
                  Reenviar a timbrado
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </>
        )}
      </Dropdown>
    );
  }
}

export default AutofacturacionItemActions;
